// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.acae11 {
  line-height: 1.52;
  font-size: 1rem;
  text-decoration: underline;
  font-family: "HM Sans Regular", "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", Osaka, "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
  font-weight: 400;
  text-transform: none;
  color: var(--base-primary-interactive);
  display: flex;
  align-items: center;
  justify-content: center;
}
.acae11:visited {
  color: var(--base-primary-interactive);
}
.acae11:hover {
  color: var(--base-primary-interactive-hover);
}
.acae11:hover svg, .acae11:hover svg path {
  fill: var(--base-primary-interactive-hover);
}
.acae11:active {
  color: var(--base-primary-interactive-active);
}
.acae11:active svg, .acae11:active svg path {
  fill: var(--base-primary-interactive-active);
}
.acae11 svg, .acae11 svg path {
  fill: var(--base-primary-interactive);
}
.a213fe {
  min-height: 40px;
}
.e08cca {
  min-height: 48px;
}
.bc471c {
  gap: 8px;
}
.e0a93a {
  width: -moz-fit-content;
  width: fit-content;
  display: inline-flex;
}
.b92105 {
  flex-direction: row-reverse;
}
.d2f10a {
  color: var(--base-primary-reverse);
}
.d2f10a:visited {
  color: var(--base-primary-reverse);
}
.d2f10a:hover {
  color: var(--base-primary-reverse-interactive-hover);
}
.d2f10a:hover svg, .d2f10a:hover svg path {
  fill: var(--base-primary-reverse-interactive-hover);
}
.d2f10a:active {
  color: var(--base-primary-reverse-interactive-active);
}
.d2f10a:active svg, .d2f10a:active svg path {
  fill: var(--base-primary-reverse-interactive-active);
}
.d2f10a svg, .d2f10a svg path {
  fill: var(--base-primary-reverse);
}`, "",{"version":3,"sources":["webpack://./node_modules/@hm-group/fabric-components/dist/esm/brand/hm/components/Links/GhostLink/GhostLink.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,eAAe;EACf,0BAA0B;EAC1B,wIAAwI;EACxI,gBAAgB;EAChB,oBAAoB;EACpB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,qCAAqC;AACvC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,QAAQ;AACV;AACA;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,oDAAoD;AACtD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,oDAAoD;AACtD;AACA;EACE,iCAAiC;AACnC","sourcesContent":[".acae11 {\n  line-height: 1.52;\n  font-size: 1rem;\n  text-decoration: underline;\n  font-family: \"HM Sans Regular\", \"ヒラギノ角ゴ Pro W3\", \"Hiragino Kaku Gothic Pro\", Osaka, \"メイリオ\", Meiryo, \"ＭＳ Ｐゴシック\", \"MS PGothic\", sans-serif;\n  font-weight: 400;\n  text-transform: none;\n  color: var(--base-primary-interactive);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.acae11:visited {\n  color: var(--base-primary-interactive);\n}\n.acae11:hover {\n  color: var(--base-primary-interactive-hover);\n}\n.acae11:hover svg, .acae11:hover svg path {\n  fill: var(--base-primary-interactive-hover);\n}\n.acae11:active {\n  color: var(--base-primary-interactive-active);\n}\n.acae11:active svg, .acae11:active svg path {\n  fill: var(--base-primary-interactive-active);\n}\n.acae11 svg, .acae11 svg path {\n  fill: var(--base-primary-interactive);\n}\n.a213fe {\n  min-height: 40px;\n}\n.e08cca {\n  min-height: 48px;\n}\n.bc471c {\n  gap: 8px;\n}\n.e0a93a {\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n  display: inline-flex;\n}\n.b92105 {\n  flex-direction: row-reverse;\n}\n.d2f10a {\n  color: var(--base-primary-reverse);\n}\n.d2f10a:visited {\n  color: var(--base-primary-reverse);\n}\n.d2f10a:hover {\n  color: var(--base-primary-reverse-interactive-hover);\n}\n.d2f10a:hover svg, .d2f10a:hover svg path {\n  fill: var(--base-primary-reverse-interactive-hover);\n}\n.d2f10a:active {\n  color: var(--base-primary-reverse-interactive-active);\n}\n.d2f10a:active svg, .d2f10a:active svg path {\n  fill: var(--base-primary-reverse-interactive-active);\n}\n.d2f10a svg, .d2f10a svg path {\n  fill: var(--base-primary-reverse);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
